import { AddNewListingIcon, AuctionResultsIcon, FurnishedIcon, HomePriceGuideIcon, NextInspectionIcon, NotificationIcon, PastSalesIcon, ShortTermIcon } from '@domain-group/fe-co-icon';
var SEARCH_EVENT = 'search';
var CTA_DRIVER_EVENT = 'cta_driver';
export var OptionMap = {
  'home-price-guide': {
    icon: HomePriceGuideIcon,
    label: 'New price for properties',
    event: SEARCH_EVENT
  },
  'past-sales': {
    icon: PastSalesIcon,
    label: 'Past sales data',
    event: CTA_DRIVER_EVENT,
    primaryCategory: 'Research',
    pageType: 'Index'
  },
  'auction-results': {
    icon: AuctionResultsIcon,
    label: 'Past weeks auction results',
    event: SEARCH_EVENT
  },
  notification: {
    icon: NotificationIcon,
    label: 'Create property alert',
    event: CTA_DRIVER_EVENT,
    primaryCategory: 'Property Alerts',
    pageType: 'Index'
  },
  'next-inspection': {
    icon: NextInspectionIcon,
    label: 'Open for inspection',
    event: SEARCH_EVENT
  },
  furnished: {
    icon: FurnishedIcon,
    label: 'Fully furnished',
    event: SEARCH_EVENT
  },
  'short-term': {
    icon: ShortTermIcon,
    label: 'Short term lease',
    event: SEARCH_EVENT
  },
  'add-new-listing': {
    icon: AddNewListingIcon,
    label: 'Place share listing',
    event: CTA_DRIVER_EVENT
  }
};